Vue.component('seat-selection', {
    props: {
        bus: Object,
        guid: String,
        passengerCount: {
            type: Number,
            default: 1
        }
    },
    data: function(){
        return {
            selectedBus: null,
            seats: [],
            selectedGender: null,
            selectedSeats: {}, // key is seat number
            availableSingleSeatMan: 0,
            availableSingleSeatWoman: 0,
            hasDiffferentPrices:false,
        }
    },
    created: function(){
        this.fetchBusData();
    },
    methods: {
        isSelectedGenderWoman: function(){
            return this.selectedGender == 1;
        },
        hasBusSingleSeat: function(){
            return this.bus.busSeatLayoutType == "2+1";
        },
        isSeatAtSingleSide: function(index){
            return index % 5 == 0;
        },
        isSingleSeatGenderCountAvailable: function(woman){
            var count = woman ? this.availableSingleSeatWoman : this.availableSingleSeatMan;
            return count > -1;
        },
        isNextSeatSellable: function(index){
            var nextIndex = -1;
            var mode = index % 5;
            if(mode == 0 || mode == 3){
                nextIndex = index + 1;
            }
            else if (mode == 1 || mode == 4){
                nextIndex = index - 1;
            }
            var seat = this.seats[nextIndex];

            var alreadySelected = seat.seatNumber in this.selectedSeats;
            return seat.sellable && !alreadySelected;
        },

        increaseSingleSeatGenderCount: function(isWoman){
            if (isWoman){
                this.availableSingleSeatWoman++;
            }
            else{
                this.availableSingleSeatMan++;
            }
        },
        decreaseSingleSeatGenderCount: function(isWoman){
            if (isWoman){
                this.availableSingleSeatWoman--;
            }
            else{
                this.availableSingleSeatMan--;
            }
        },

        isSingleSeatRuleApplicable: function(index){
            // http://tasks.iati.com/browse/CARENGINE-86
            // 2 li koltuklarda tekli kadin yada erkek satin alma siniri icin yapilmistir
            return (this.hasBusSingleSeat() && !this.isSeatAtSingleSide(index) && this.isNextSeatSellable(index)) ||
                (!this.hasBusSingleSeat() && this.isNextSeatSellable(index));
        },

        fetchBusData: function () {
            var vm = this;
            this.$emit('seatselectionchanged',status);
            $.ajax({
                type: "POST",
                url : "/bus/search",
                dataType : "json",
                data : {
                    output: 'json',
                    guid: vm.guid,
                    fareKey: vm.bus.fareKey
                }
            })
            .then(function(response) {
                if(response){
                    vm.selectedBus = response.busResults;
                    vm.seats =  vm.initializeSeats(response.busResults.seats);

                    vm.availableSingleSeatMan = response.busResults.availableSingleSeatMan;
                    vm.availableSingleSeatWoman = response.busResults.availableSingleSeatWoman;

                    $('html, body').animate({
                        scrollTop: $('#depSeat').offset().top
                    }, 500);

                    vm.selectGender(3);
                }
            })
            .fail(function(data){
                // closeLoaderBox();
                // alert("dss");
            })
        },
        getStyle: function (seat, index) {
            var row = Math.floor(index / 5) + 1;
            var col = (index % 5) + 1;

            var topPixel = (5 - col) * 45;
            var leftPixel = (row - 1 ) * 45;

            topPixel += 'px';
            leftPixel += 'px';

            var style = {
                top: topPixel,
                left: leftPixel,
            };

            if (seat.seatStr == 'MA' || seat.seatStr == 'SA' ){
                style['background'] = "url('/images/bus/table.png') no-repeat center";
            }
            return style;
        },
        getClass: function (seat) {
            var otherStatus = seat.status != 0 && seat.status != 1 && seat.status != 3;

            var cls = {
                seat: true,
                'empty-seat': seat.status == 0,
                'woman-seat': seat.status == 1,
                'man-seat': seat.status == 3,
                'full-seat': otherStatus
            };

            return cls;
        },
        selectSeat: function(seat, index){
            if(this.selectedGender == null){
                alert(FmtMessage.getMessage('js.bus.passenger.select.warning'));
            }
            if (!(seat.seatNumber in this.selectedSeats) && this.passengerCount > 1 && Object.keys(this.selectedSeats).length == this.passengerCount){
                alert(FmtMessage.getMessage('js.bus.max.passenger.warning'));
                return;
            }

            if (seat.sellable && !seat.disabled && this.selectedGender){

                if (this.passengerCount == 1 && Object.keys(this.selectedSeats).length > 0){
                    var key = Object.keys(this.selectedSeats)[0];
                    var prevSeat = this.selectedSeats[key];
                    prevSeat = this.seats[prevSeat.index];
                    prevSeat.class['woman-seat'] = false;
                    prevSeat.class['man-seat'] = false;
                    prevSeat.class['empty-seat'] = true;

                    this.seats[prevSeat.index] = prevSeat;
                    this.selectedSeats = {};
                    this.selectedSeats=Object.assign({},this.selectedSeats);
                    this.seats = this.seats.slice();

                    this.addSelectedGenderToSeat(seat, index);
                }
                else if (seat.seatNumber in this.selectedSeats){
                    delete this.selectedSeats[seat.seatNumber];
                    this.selectedSeats=Object.assign({},this.selectedSeats);

                    seat.class['woman-seat'] = false;
                    seat.class['man-seat'] = false;
                    seat.class['empty-seat'] = true;
                }
                else {
                    // add new seat
                    this.addSelectedGenderToSeat(seat, index);
                }

                this.seats[index] = seat;
                this.seats = this.seats.slice();
            }
        },
        addSelectedGenderToSeat: function(seat, index){
            seat.class['woman-seat'] = this.isSelectedGenderWoman();
            seat.class['man-seat'] = !this.isSelectedGenderWoman();
            seat.class['empty-seat'] = false;

            this.selectedSeats[seat.seatNumber] = {
                gender: this.isSelectedGenderWoman() ? 'K' : 'E',
                seatNumber: seat.seatNumber,
                voyageTrackingNumber: this.selectedBus.voyageTrackingNumber,
                index: index
            }
            this.selectedSeats=Object.assign({},this.selectedSeats);
        },
        selectGender: function (gender) {
            this.selectedGender = gender;
            this.disableSeatsByGender(gender);
        },
        initializeSeats: function (seats) {
            var nonSeats = ['KO', 'KA', 'PI', 'MA', 'SA'];
            var price =0; 
            var vm = this;
            return seats.map(function (seat, index) {
                seat.style = vm.getStyle(seat, index);
                seat.isSeat = !nonSeats.includes(seat.seatStr);

                if (seat.isSeat){
                    seat.class = vm.getClass(seat, index);
                    if(!vm.hasDiffferenPrices){
                    if(price==0) price=seat.seatPriceWeb.toFixed(2)
                    else if(seat.seatPriceWeb>0 && seat.seatPriceWeb.toFixed(2)!=price){
                    	vm.hasDiffferentPrices=true;
                      }
                    }
                }
                seat.disabled = seat.isSeat && seat.status != 0;
                seat.sellable = seat.isSeat && seat.status == 0;
                                
                return seat;
            });
        },
        disableSeatsByGender: function (selectedGender) {
            // statusNext = 0 ==> free
            // statusNext = 1 ==> woman
            // statusNext = 2 ==> man
            var disabledGender = selectedGender == 1 ? 2 : 1;

            this.seats = this.seats.map(function (seat) {

                if (seat.disabled){
                    seat.class['unavailable-seat'] = false;
                    seat.class['empty-seat'] = true;
                    seat.disabled = false;
                }

                if (seat.isSeat && seat.nextSeatStatus == disabledGender && seat.status == 0){
                    seat.class['unavailable-seat'] = true;
                    seat.class['empty-seat'] = false;
                    seat.disabled = true;
                }
                return seat;
            });
        },
        reset: function () {
            this.selectedBus = null;
            this.selectedGender = null;
            this.selectedSeats = {};
            this.seats = [];
        },
        buyTicket: function () {

            this.availableSingleSeatMan = this.selectedBus.availableSingleSeatMan;
            this.availableSingleSeatWoman = this.selectedBus.availableSingleSeatWoman;

            var status = true;
            var isErrorGenderWoman = false;
            for (seatNum in this.selectedSeats){

                var seat = this.selectedSeats[seatNum];
                var isWoman = seat.gender == 'K';

                var valid = true;

                if (this.isSingleSeatRuleApplicable(seat.index)){
                    this.decreaseSingleSeatGenderCount(isWoman);
                    valid =  this.isSingleSeatGenderCountAvailable(isWoman);
                }

                status = status && valid;

                if (!valid){
                    isErrorGenderWoman = isWoman;
                    break;
                }

            }

            if (!status) {
                var fmt = isErrorGenderWoman ? 'js.bus.max.single.woman.warning' : 'js.bus.max.single.man.warning';
                alert(FmtMessage.getMessage(fmt));
            }
            else {
                var mainForm = document.forms['mainForm'];

                this.addHidden(mainForm, "fareKey", this.bus.fareKey);
                //addHidden(mainForm, "fareKeyRet", $('#fareKeyRet').val());
                this.addHidden(mainForm, "guid", this.guid);
                this.addHidden(mainForm, "departureSeatPlan", ''+JSON.stringify(Object.values(this.selectedSeats)).replace(/\"/g,"'"));
                //addHidden(mainForm, "returnSeatPlan", ''+JSON.stringify(retSelecteds).replace(/\"/g,"'"));

                mainForm.submit();
            }
        },
        addHidden: function (theForm, key, value) {
            // Create a hidden input element, and append it to the form:
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            theForm.appendChild(input);
        }
        
    },
    
    watch: {
    	
        bus: {
            handler: function(){
            },
            deep: true
        },
        selectedSeats: {
            handler: function(oldvalue,newvalue){
            	var status = Object.keys(this.selectedSeats).length==this.passengerCount;
            	this.$emit('seatselectionchanged',status);
            },
            deep: true
        },
                 
    },
});

// status = 0 ==> free
// status = 1 ==> woman
// status = 3 ==> man
// status = 4 ==> full
// statusNext = 0 ==> free
// statusNext = 1 ==> woman
// statusNext = 2 ==> man